import { TablePagination, useMediaQuery } from '@mui/material';
import React from 'react';
export const Pagination = (props) => {
    var _a, _b;
    const [rowsPerPage, setRowsPerPage] = React.useState((_a = props.initialRowsPerPage) !== null && _a !== void 0 ? _a : 50);
    const upSmScreen = useMediaQuery((theme) => theme.breakpoints.up('sm'));
    return (React.createElement(TablePagination, { rowsPerPageOptions: upSmScreen ? [10, 20, 50, 100] : [(_b = props.initialRowsPerPage) !== null && _b !== void 0 ? _b : 50], component: 'div', count: props.total, rowsPerPage: rowsPerPage, page: props.page, onPageChange: (event, page) => props.onChange(page, rowsPerPage), onRowsPerPageChange: (event) => {
            const rowsPerPage = parseInt(event.target.value);
            setRowsPerPage(rowsPerPage);
            props.onChange(0, rowsPerPage);
        }, SelectProps: {
            SelectDisplayProps: { 'data-test': 'rows-per-page-select' },
        }, backIconButtonProps: { 'data-test': 'pagination-back-button' }, nextIconButtonProps: { 'data-test': 'pagination-next-button' } }));
};
